<template>
  <div class="kp-modular-user">
    <div class="kp-modular-nav">
      <name></name>
      <div class="kp-modular-nav-right">
        <ul class="kp-list-actions clearfix">
          <export></export>
          <publish></publish>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Name from './Name.vue';
import Export from './buttons/Export.vue';
import Publish from './buttons/Publish.vue';

export default {
  components: {
    Name,
    Export,
    Publish,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?2d6f4f00
 **/